import React, { useContext, useEffect,useState } from 'react'
import '../../../styles/devotionalVideos.css'
import EachRow from './eachRow';
import Skeleton from '../../pages/skelton.jsx';
import { Helmet } from 'react-helmet-async';
import DevotionalBreadCrumb from '../devotionalBreadCrumb.jsx';
import { DeviceContext } from '../index.jsx';
import PageAds from '../../common/pageAds.jsx';








const DevotionalVideos = ({data:serverData}) => {

                 const ssrVideosData = serverData?.[0]?.videosPage?.videosPageData || null   
                 const ssrVideosDataError = serverData?.[0]?.videosPage?.videosPageDataError || null   
                 let seperatedCatData=ssrVideosData?.reduce((acc, curr) => {
                   const key = curr.video_cat;
                
                  if (!acc[key]) {
                    acc[key] = [];
                  }
                
                  acc[key].push(curr);
                  return acc;
                }, {});

 
                 const [data,setData]=useState(seperatedCatData)

                 const [error,setError]=useState(ssrVideosDataError)
                 
                 const [loading ,setLoading]=useState(false)
                  const {mobile,setMobile,containerRef} = useContext(DeviceContext)
                 
               

  useEffect(() => {

       if (ssrVideosData) {

         setError(null)
         setLoading(false)
 
         return;
         
         
       }

       setLoading(true)
       setData(null)
       const getData = async () => {
                 
               try {

                 const res= await fetch("https://www.teluguone.com/devotional_api/devotionalVideoGalleryJson");
                 if (!res.ok) throw new Error('Response Was Not Ok.')
                
                  let data=await res.json()
                 let seperatedCatData=data.devotional_categories.reduce((acc, curr) => {
                  const key = curr.video_cat;
                
                  if (!acc[key]) {
                    acc[key] = [];
                  }
                
                  acc[key].push(curr);
                  return acc;
                }, {});


              
                    
                    setData(seperatedCatData);
                    setLoading(false)
                    setError(null)
             
                
               } catch (error) {

             
                setData([]);
                setLoading(false)
                setError(error.message)
              

                console.log(`Error : ${error.message}`)
              }
        }
        getData()

  },[])





  if (loading ) {
     
    return (
      <div className='devotional-videos'>
      <div className='container-fluid g-0'>
     {Array(12).fill("m").map((_,index) =>
        
       <div className='row g-0' key={index+1}>
         {Array(10).fill("o").map((_,index) =>
               <div key={index} className="col-6 col-sm-4 col-md-3">
                       <Skeleton type={"square"} />
                       <Skeleton type={"title"} />
               </div>
           ) }
      </div> 
     ) }
     </div>
    </div>
    )
  }

  if (error) {
      return (
          <div className='devotional-videos'>
           <div className='container-fluid g-0'>
                                <div className='row g-0'>    
                                   <div className="col-12">
                                     <div className="json-loading-error-div">
                                        <img  src="/devotional/assets/images/json_error.png" alt="json_error" />
                                     </div>
                                  </div>
                                </div>
                              </div>
         </div>
      )
  }


   

 
  return (
        <div className='devotional-videos'>
         <Helmet><title>Telugu Bhakti Videos | Telugu Devotional Videos | TeluguOne Devotional</title></Helmet>
           <div className='container-fluid g-0'>
           <DevotionalBreadCrumb  breadCrumb={"Video Gallery"}  />    
           { data && Object.keys(data).map((key, index) => (
             <EachRow key={index} more_index={index}  keyText={key} item={data[key]} />
          ))}
                 
           </div>
          <PageAds mobile={mobile} containerRef={containerRef} />  
        </div>
      
  )
}

export default DevotionalVideos;


